export const EntityAndRoleMap = {
    Tenant: {
        EntityTypeId: 59,
        Name: 'Tenant',
    },
    Cosigner: {
        EntityTypeId: 60,
        Name: 'Cosigner'
    },
    RentalOwner: {
        EntityTypeId: 1,
        Name: 'Rental owner'
    },
    StaffMember: {
        EntityTypeId: 14,
        Name: 'Staff member'
    },
    AdditionalSigner: {
        EntityTypeId: 97,
        Name: 'Additional signer'
    }
};

const initEntityTypeToRole = {},
    initRoleToEntityType = {};

Object.entries(EntityAndRoleMap).forEach((entry) => {
    const key = entry[0],
        value = entry[1];
    initEntityTypeToRole[value.EntityTypeId] = value.Name;
    initRoleToEntityType[key] = value.EntityTypeId;
});

export const EntityTypeToRole = initEntityTypeToRole; // { 1: 'Rental owner'}
export const RoleToEntityType = initRoleToEntityType; // { RentalOwner: 1 }
export const SignerRoleDropdownOptions = Object.values(EntityAndRoleMap); // [{EntityTypeId: 1, Name: 'Rental owner'}]
